import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const studioApi = createApi({
  reducerPath: "studioApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
  }),
  endpoints: (builder) => ({
    fetchStudio: builder.query({
      query: (lang) => ({
        url: "studios",
        headers: {
          lang: lang,
        },
      }),
      staleTime: 1000 * 60 * 5,
    }),
  }),
});

export const { useFetchStudioQuery } = studioApi;
